import React from 'react';
import { motion } from 'framer-motion';
import './Header.css';

const Header = ({ category, lastUpdated }) => {
  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="display-header"
    >
      <div className="header-row">
        <div className="header-left">
          <div className="lavender-lounge-wrapper">
            <span className="lavender-lounge-title">Lavender Lounge</span>
            <span className="lavender-lounge-subtitle">Hanimaadhoo</span>
          </div>
        </div>
        <div className="header-center">
          <h1 className="header-title">{category.charAt(0).toUpperCase() + category.slice(1)} Flights</h1>
        </div>
        <div className="header-right">
          <div className="update-wrapper">
            <div className="update-section">
              <span className="update-label">Last Updated:</span>
              <motion.span 
                key={lastUpdated}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                className="update-time"
              >
                {formatTime(lastUpdated)}
              </motion.span>
            </div>
            <span className="powered-by">powered by AriWorks</span>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;

